/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_DoneInputs */

const en_cc_done = /** @type {(inputs: Cc_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link was added to Location. Review the draft in Google Calendar; you decide when to save and send invitations.`)
};

const id_cc_done = /** @type {(inputs: Cc_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan ditambahkan ke kolom Lokasi. Tinjau draf di Google Calendar; Anda sendiri yang menyimpan acara dan mengirim undangan.`)
};

/**
* | output |
* | --- |
* | "The link was added to Location. Review the draft in Google Calendar; you decide when to save and send invitations." |
*
* @param {Cc_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_done = /** @type {((inputs?: Cc_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_done(inputs)
	return en_cc_done(inputs)
});